export default "__VITE_ASSET__Suzsuvuq__"